// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BHK1","largestCol":"styles_largestCol__1ghVH","smallestCol":"styles_smallestCol__CNcce"};